<template>
    <div
        class="burger-menu flex flex-column justify-between"
        :class="{'burger-menu_active': isOpen }"
        @click="$emit('click')"
    >
        <div class="burger-menu__item top" />
        <div class="burger-menu__item bottom" />
    </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'HeaderBurgerMenu',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
});
</script>

<style lang="scss" scoped>
@import '@/assets/styles/common/header/header-burger';
</style>
